var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitOneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.614,
    height: 17.5,
    viewBox: "0 0 299.614 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_recruit_one_icon_v2",
    transform: "translate(6920.35 259.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139012",
    "data-name": "\\uD328\\uC2A4 139012",
    d: "M.15-17.5v3.825H3.4V0H8.35V-17.5Z",
    transform: "translate(-6920.5 -241.918)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139010",
    "data-name": "\\uD328\\uC2A4 139010",
    d: "M280.984.5H0v-1H280.984Z",
    transform: "translate(-6905.659 -247.918)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139011",
    "data-name": "\\uD328\\uC2A4 139011",
    d: "M3.939,0A3.939,3.939,0,1,1,0,3.939,3.939,3.939,0,0,1,3.939,0Z",
    transform: "translate(-6628.615 -251.857)",
    fill: "#1876d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitOneIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_one_icon.2f61bdb283e146d12a9a1d0d20027ffb.svg";
export { ForwardRef as ReactComponent };